import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { nomorNegatif, PESAN_KUNCI_VERSI, ringkasPerDimensi } from "@/lib/surveiEditor";

// Konfirmasi kunci versi: tidak bisa dibatalkan. Menampilkan ringkasan isi yg TERSIMPAN (bukan perubahan di layar).
export default function SurveiKunciVersiDialog({ open, isi, label, onBatal, onKunci }) {
    if (!isi) return null;
    const negatif = nomorNegatif(isi);
    return (
        <AlertDialog open={open} onOpenChange={(o) => !o && onBatal()}>
            <AlertDialogContent data-testid="survei-kunci-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle>Kunci versi {label}?</AlertDialogTitle>
                    <AlertDialogDescription>{PESAN_KUNCI_VERSI}</AlertDialogDescription>
                </AlertDialogHeader>
                <div className="space-y-2 text-sm text-slate-700" data-testid="survei-kunci-ringkasan">
                    <p><span className="font-semibold">{isi.butir.length} butir</span> · butir berkalimat negatif: {negatif.length ? negatif.join(", ") : "tidak ada"}</p>
                    <ul className="grid grid-cols-1 gap-x-4 text-xs sm:grid-cols-2">
                        {ringkasPerDimensi(isi).map((d) => <li key={d.kode}>{d.kode} · {d.nama}: {d.jumlah}</li>)}
                    </ul>
                </div>
                <AlertDialogFooter>
                    <AlertDialogCancel>Batal</AlertDialogCancel>
                    <AlertDialogAction onClick={onKunci} data-testid="survei-kunci-ya">Ya, kunci versi</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
